export default class {
	tipo
	buscarTodos

	constructor(tipo, buscarTodos, nome) {
		this.tipo = tipo
		this.buscarTodos = buscarTodos
	}
}
